import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  ClientDashboard,
  ClientDashboardResponse,
  ScheduleVisit,
} from '@models';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { dateUTC } from '@utilities';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ClientDashboardService {
  private dashboard = environment.CLIENTE;

  private hourInSeconds = 60 * 60;

  public seconds: Subject<number> = new Subject<number>();

  constructor(private readonly http: HttpClient) {}

  public getDashboard(): Observable<ClientDashboard> {
    return this.http
      .get<ClientDashboardResponse>(this.dashboard.DASHBOARD)
      .pipe(
        map(({ response }) => {
          const { upcomingVisits, history } = response;

          const formatDates = (e: ScheduleVisit): ScheduleVisit => {
            return {
              ...e,
              visitDateTime: dateUTC(e.visitDateTime),
            };
          };

          if (upcomingVisits.length) {
            const diffSeconds = moment().diff(
              moment(upcomingVisits[0].visitDateTime),
              'seconds'
            );

            this.seconds.next(
              diffSeconds > 0
                ? this.hourInSeconds - diffSeconds
                : diffSeconds * -1 + this.hourInSeconds
            );
          }

          return {
            upcomingVisits: upcomingVisits.map((e) => formatDates(e)),
            history: history.map((e) => formatDates(e)),
          };
        })
      );
  }
}
